import React from "react";

import { StyledSVG } from "../StyledIcon";

export const BookmarkIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M6.75 2.25H7.5C7.5 1.83579 7.16422 1.5 6.75 1.5V2.25ZM6.75 15.75V16.5C7.16422 16.5 7.5 16.1642 7.5 15.75H6.75ZM6.75 1.5H3.25V3H6.75V1.5ZM1.5 3.25V14.75H3V3.25H1.5ZM3.25 16.5H6.75V15H3.25V16.5ZM7.5 15.75V2.25H6V15.75H7.5ZM1.5 14.75C1.5 15.7165 2.2835 16.5 3.25 16.5V15C3.11193 15 3 14.8881 3 14.75H1.5ZM3.25 1.5C2.2835 1.5 1.5 2.2835 1.5 3.25H3C3 3.11193 3.11193 3 3.25 3V1.5Z"
        fill={iconColor}
      />
      <path
        d="M6.75 2.25V1.5C6.33579 1.5 6 1.83579 6 2.25H6.75ZM6.75 15.75H6C6 16.1642 6.33579 16.5 6.75 16.5V15.75ZM14.75 1.5H6.75V3H14.75V1.5ZM6 2.25V15.75H7.5V2.25H6ZM6.75 16.5H14.75V15H6.75V16.5ZM16.5 14.75V3.25H15V14.75H16.5ZM14.75 16.5C15.7165 16.5 16.5 15.7165 16.5 14.75H15C15 14.8881 14.8881 15 14.75 15V16.5ZM14.75 3C14.8881 3 15 3.11193 15 3.25H16.5C16.5 2.2835 15.7165 1.5 14.75 1.5V3Z"
        fill={iconColor}
      />
    </StyledSVG>
  );
};
